var exports = {
  "c1": "mainChart___vafEy",
  "DD": "title__QufDU4",
  "VA": "subtitle__07A7Cz",
};

module.exports = exports;
